import React, { ElementType } from 'react';
import parse from 'html-react-parser';
import Image from '../image/Image';
import { ISpotCard } from '../../interfaces';
import { removeExtraSpaces } from '../../scripts/helpers';
import { sharedIconsPath } from '../../scripts/data';

type SpotProps = {
  className?: string;
  cards: ISpotCard[];
  headingTag?: ElementType<any>;
  cardsPerPage?: number;
};

const SpotIconCards = ({ className = '', cards, headingTag, cardsPerPage }: SpotProps) => {
  const returnColSize = () => {
    const cardsNumber = cardsPerPage || cards.length;
    const remainder = cardsNumber % 3;
    return remainder === 0 ? 'col-lg-4' : 'col-lg-6';
  };

  const CustomHeadingTag = headingTag || 'h3';

  return (
    <div className={`row gy-3 gy-lg-4 ${className}`}>
      {cards.map((element: ISpotCard, i: number) => {
        const CardTag = element.link ? 'a' : 'div';
        return (
          <div
            key={`${i}-step-spot-card`}
            className={removeExtraSpaces(`${returnColSize()}`)}>
            <CardTag
              {...(element.link ? { href: element.link } : {})}
              {...(element.dataOp ? { 'data-op': element.dataOp } : {})}
              {...(element.dataLink ? { 'data-link-both': element.dataLink } : {})}
              className={`card card-light d-flex ${
                element.subcopy ? '' : 'align-items-center'
              } ${element.link ? 'card-link ' : ''}`}>
              {element.icon && (
                <Image
                  className="spot-icon-md me-3"
                  src={`${sharedIconsPath}/${element.icon}`}
                  lazyLoading
                  width="48"
                  height="48"
                  alt={element.alt || ''}
                />
              )}
              <div>
                {element.preHeading && (
                  <p className="mb-2 text-gray eyebrow-text">
                    {typeof element.preHeading === 'string'
                      ? parse(element.preHeading)
                      : element.preHeading}
                  </p>
                )}
                <CustomHeadingTag className={`h5 ${element.subcopy ? '' : 'mb-0'}`}>
                  {typeof element.heading === 'string' ? parse(element.heading) : element.heading}
                </CustomHeadingTag>
                {element.subcopy && (
                  <p className="mb-0 text-gray">
                    {typeof element.subcopy === 'string' ? parse(element.subcopy) : element.subcopy}
                  </p>
                )}
              </div>
            </CardTag>
          </div>
        );
      })}
    </div>
  );
};

export default SpotIconCards;
